<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <h1>Login</h1>
                  <p class="text-muted">Sign In to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="admin email" autocomplete="username email" v-model="email"/>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="Password" autocomplete="current-password" v-model="password"/>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button variant="primary" class="px-4" @click="signIn">Login</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0" @click="sendPasswordResetEmail(email)">Forgot password?</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <h2>Sign up</h2>
                  <p>If you don't have admninistration account, contact System Admin</p>
                  <b-button class="active mt-3" @click="contactAdmin" variant="primary">Contact System Admin!</b-button>
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import VueNotifications from 'vue-notifications'

export default {
  name: 'Login',
  created: function() {
      this.$store.commit('setUser')
  },
  data: function() {
      return {
          email: null,
          password: null
      }
  },
  methods: {
      contactAdmin(ev) {
          console.log('contactAdmin')
          location.href = 'mailto:admin@hecerion.com'
      },
      sendPasswordResetEmail(email) {
          this.$firebase.auth().sendPasswordResetEmail(email)
          .then(() => {
              this.$options.notifications.showInfoMsg.message = "Successfully sent email to " + email
              this.showInfoMsg()
          })
          .catch(error => {
              console.error(error)
              this.$options.notifications.showErrorMsg.message = error.message
              this.showErrorMsg()
          })
      },
      signIn(ev) {
          console.log("singIn")
          let _this = this
          ev.preventDefault()

          this.$firebase.auth().onAuthStateChanged(user => {
              console.log('onAuthStateChanged')
          })
          
          this.$firebase.auth().signInWithEmailAndPassword(this.email, this.password)
          .then(userCredential => {
              console.log(userCredential)
              _this.$store.commit('setUser', userCredential.user)
              return  _this.$firebase.auth().currentUser.getIdTokenResult()
          })
          .then(idTokenResult => {
              if (!idTokenResult.claims.admin) {
                  _this.$store.commit('setUser', null)
                  throw new Error('No Admin Previlege')
              }
              _this.$http.defaults.headers.common.Authorization = `Bearer ${idTokenResult.token}`
              _this.$router.push('/')
          })
          .catch(error => {
              console.log(error)
              _this.$options.notifications.showErrorMsg.message = error.message
              _this.showErrorMsg()
          })
      }
    },
    notifications: {
        showErrorMsg: {
            type: VueNotifications.types.error,
            title: 'Fail to sign in',
            message: ''
        },
        showInfoMsg: {
          type: VueNotifications.types.info,
          title: 'Information',
          message: ''
      }
    }
}
</script>
